import languageReducer from './language.reducer';

export { default as languageActions } from './language.actions';
export { types as languageTypes } from './language.actions';
export { default as languageSelectors } from './language.selectors';


export default languageReducer;
